/**
 * Fake-select
 */

(function ($) {

  $(document).on('click', '.fake-select__header', (e) => {

    console.log('fake select content 1');


    e.stopPropagation();
    e.preventDefault();
    let target = $(e.currentTarget);
    let parent = target.parent();
    parent.toggleClass('open');
    parent.find('.fake-select__content').slideToggle("fast");
  });

  $(document).on('click', () => {
    $('.fake-select').removeClass('open').find('.fake-select__content').slideUp('fast');
  });

  // prevent closing on click inside fake select content
  $(document).on('click', '.fake-select__content', (e) => {

    console.log('fake select content 2');
    e.stopPropagation();



  });

  $(document).on('click', '.fake-select__item', (e) => {

    console.log('fake select content 1');
    const option = $(e.currentTarget);
    const parent = option.parents('.fake-select').eq(0);
    const valueField = parent.find('.fake-select__value');
    if (valueField.length) {
      valueField.text(option.text());
      parent.find('.fake-select__item').removeClass('is-active');
      option.addClass('is-active');
    }
  });

}(jQuery));
